import Layouts from "./layouts/index.js";
const { // plop_marker:segment_index_import_layout
HubspotWithQuoteCarouselForm, HubspotForm, HubspotOnDarkBackgroundForm, HubspotOnPurpleBackgroundForm, MondayFormForm, HubspotWithBulletsSideBySideForm, HubspotAndLogosForm, ZendeskSideBySideForm, ZendeskForm, HubspotSideBySideForm } = Layouts;
export default {
    // plop_marker:segment_index_add_layout
    HubspotWithQuoteCarouselFormComponent: {
        type: "HubspotWithQuoteCarouselFormComponent",
        title: "Hubspot With Quote Carousel",
        imgSrc: "/static/img/segments/layouts/hubspot-with-quote-carousel-form.png",
        config: HubspotWithQuoteCarouselForm.HubspotWithQuoteCarouselFormConfig,
        advancedConfig: HubspotWithQuoteCarouselForm.HubspotWithQuoteCarouselFormAdvancedConfig,
        component: HubspotWithQuoteCarouselForm.HubspotWithQuoteCarouselFormComponent
    },
    HubspotFormComponent: {
        type: "HubspotFormComponent",
        title: "Hubspot",
        imgSrc: "/static/img/segments/layouts/hubspot-form.png",
        config: HubspotForm.HubspotFormConfig,
        advancedConfig: HubspotForm.HubspotFormAdvancedConfig,
        component: HubspotForm.HubspotFormComponent
    },
    HubspotOnDarkBackgroundFormComponent: {
        type: "HubspotOnDarkBackgroundFormComponent",
        title: "Hubspot On Dark Background",
        imgSrc: "/static/img/segments/layouts/hubspot-on-dark-background-form.png",
        config: HubspotOnDarkBackgroundForm.HubspotOnDarkBackgroundFormConfig,
        advancedConfig: HubspotOnDarkBackgroundForm.HubspotOnDarkBackgroundFormAdvancedConfig,
        component: HubspotOnDarkBackgroundForm.HubspotOnDarkBackgroundFormComponent
    },
    HubspotOnPurpleBackgroundFormComponent: {
        type: "HubspotOnPurpleBackgroundFormComponent",
        title: "Hubspot On Purple Background",
        imgSrc: "/static/img/segments/layouts/hubspot-on-purple-background-form.png",
        config: HubspotOnPurpleBackgroundForm.HubspotOnPurpleBackgroundFormConfig,
        advancedConfig: HubspotOnPurpleBackgroundForm.HubspotOnPurpleBackgroundFormAdvancedConfig,
        component: HubspotOnPurpleBackgroundForm.HubspotOnPurpleBackgroundFormComponent
    },
    MondayFormFormComponent: {
        type: "MondayFormFormComponent",
        title: "Monday Form",
        imgSrc: "/static/img/segments/layouts/monday-form-form.png",
        config: MondayFormForm.MondayFormFormConfig,
        advancedConfig: MondayFormForm.MondayFormFormAdvancedConfig,
        component: MondayFormForm.MondayFormFormComponent
    },
    HubspotWithBulletsSideBySideFormComponent: {
        type: "HubspotWithBulletsSideBySideFormComponent",
        title: "Hubspot With Bullets Side By Side",
        imgSrc: "/static/img/segments/layouts/hubspot-with-bullets-side-by-side-form.png",
        config: HubspotWithBulletsSideBySideForm.HubspotWithBulletsSideBySideFormConfig,
        advancedConfig: HubspotWithBulletsSideBySideForm.HubspotWithBulletsSideBySideFormAdvancedConfig,
        component: HubspotWithBulletsSideBySideForm.HubspotWithBulletsSideBySideFormComponent
    },
    HubspotAndLogosFormComponent: {
        type: "HubspotAndLogosFormComponent",
        title: "Hubspot And Logos",
        imgSrc: "/static/img/segments/layouts/hubspot-and-logos-form.png",
        config: HubspotAndLogosForm.HubspotAndLogosFormConfig,
        advancedConfig: HubspotAndLogosForm.HubspotAndLogosFormAdvancedConfig,
        component: HubspotAndLogosForm.HubspotAndLogosFormComponent
    },
    ZendeskSideBySideFormComponent: {
        type: "ZendeskSideBySideFormComponent",
        title: "Zendesk Side By Side",
        imgSrc: "/static/img/segments/layouts/zendesk-side-by-side-form.png",
        config: ZendeskSideBySideForm.ZendeskSideBySideFormConfig,
        advancedConfig: ZendeskSideBySideForm.ZendeskSideBySideFormAdvancedConfig,
        component: ZendeskSideBySideForm.ZendeskSideBySideFormComponent
    },
    ZendeskFormComponent: {
        type: "ZendeskFormComponent",
        title: "Zendesk",
        imgSrc: "/static/img/segments/layouts/zendesk-form.png",
        config: ZendeskForm.ZendeskFormConfig,
        advancedConfig: ZendeskForm.ZendeskFormAdvancedConfig,
        component: ZendeskForm.ZendeskFormComponent
    },
    HubspotSideBySideFormComponent: {
        type: "HubspotSideBySideFormComponent",
        title: "Hubspot Side By Side",
        imgSrc: "/static/img/segments/layouts/hubspot-side-by-side-form.png",
        config: HubspotSideBySideForm.HubspotSideBySideFormConfig,
        advancedConfig: HubspotSideBySideForm.HubspotSideBySideFormAdvancedConfig,
        component: HubspotSideBySideForm.HubspotSideBySideFormComponent
    }
};
